import { render, staticRenderFns } from "./Registrar.vue?vue&type=template&id=77e52372&scoped=true"
import script from "./Registrar.vue?vue&type=script&lang=js"
export * from "./Registrar.vue?vue&type=script&lang=js"
import style0 from "./Registrar.vue?vue&type=style&index=0&id=77e52372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e52372",
  null
  
)

export default component.exports